import React from 'react';
import { useTranslation } from 'react-i18next';
import { Card } from '../../../components/ui';

interface ErrorBannerProps {
  dark: boolean;
  message: string;
}

export function ErrorBanner({ dark, message }: ErrorBannerProps) {
  const { t: tr } = useTranslation();
  return (
    <Card dark={dark} style={{ padding: 12, borderColor: '#f04438', marginBottom: 8 }}>
      <div style={{ fontSize: 13, color: '#b42318', fontWeight: 500 }}>
        {tr('dashboard.error_banner.load_failed', { message })}
      </div>
    </Card>
  );
}
